<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-items v-if="project">
      <n-input title="Ближайшая геологическая выработка №" v-bind="$form.input('p2.1')" :text="!editable" />
      <n-input title="пройдена" v-bind="$form.input('p2.2')" :text="!editable" />
      <n-input title="Абсолютные отметки: - нижнего конца от сваи " v-bind="$form.input('p2.3')" :text="!editable" />
      <n-input title="Абсолютные отметки: - поверхности грунта у сваи " v-bind="$form.input('p2.4')" :text="!editable" />
      <n-input title="Глубина забивки сваи" v-bind="$form.input('p2.5')" :text="!editable" />
      <n-input title="Расстояние выработки" v-bind="$form.input('p2.6')" :text="!editable" />
      <n-input title="Состояние головы сваи после забивки" v-bind="$form.input('p2.7')" :text="!editable" />
      <n-input title="Краткая характеристика инженерно-геологического разреза в месте расположения сваи " v-bind="$form.input('p2.8')" :text="!editable" />
      <n-input title="Температура воды (при испытаниях на акватории) " v-bind="$form.input('p2.9')" :text="!editable" />
      <n-input title="Температура воздуха " v-bind="$form.input('p2.10')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
